import { useTranslation } from 'react-i18next';

import Button from '../../../../../../components/Button';
import Dialog from '../../../../../../components/Dialog';
import RadioOption from '../../../../../../components/FormControls/RadioGroup/RadioOption';
import RadioGroup from '../../../../../../components/HookFormControls/RadioGroup';
import { StudentResponses } from '../../../../../../db/polls/types';
import { i18nNS } from '../../../../../../i18n';
import CheckmarkIcon from '../../../../../../icons/CheckmarkIcon';
import useEditStudentResponsesDialogVM, { Props as VMProps } from './vm';

interface Props extends VMProps {}

const EditStudentResponsesDialog = ({ ...vmOptions }: Props) => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY, i18nNS.COMMON]);

  const { open } = vmOptions;
  const { formMethods, onSubmit, onCloseDialog: handleCloseDialog } = useEditStudentResponsesDialogVM(vmOptions);
  const { handleSubmit, control } = formMethods;

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={handleCloseDialog}
      header={t('student_response', { ns: i18nNS.POLL })}
      footer={
        <>
          <Button
            variant="text"
            onClick={handleCloseDialog}
            aria-label={t('click_to_close_dialog', { ns: i18nNS.COMMON })}
          >
            {t('cancel', { ns: i18nNS.GLOSSARY })}
          </Button>
          <Button
            startIcon={<CheckmarkIcon aria-hidden />}
            onClick={handleSubmit(onSubmit)}
            aria-label={t('click_to_save_student_responses', { ns: i18nNS.POLL })}
          >
            {t('save', { ns: i18nNS.GLOSSARY })}
          </Button>
        </>
      }
    >
      <RadioGroup control={control} name="studentResponses">
        <RadioOption
          value={StudentResponses.NOT_ANONYMOUS}
          aria-label={t('click_to_select_student_response_as_not_anonymous', { ns: i18nNS.POLL })}
        >
          {t('not_anonymous', { ns: i18nNS.GLOSSARY })}
        </RadioOption>
        <RadioOption
          value={StudentResponses.ANONYMOUS}
          aria-label={t('click_to_select_student_response_as_anonymous', { ns: i18nNS.POLL })}
        >
          {t('anonymous', { ns: i18nNS.GLOSSARY })}
        </RadioOption>
      </RadioGroup>
    </Dialog>
  );
};

export default EditStudentResponsesDialog;
